// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__OejTC","selectionName":"styles_selectionName__FEgOQ","link":"styles_link__d26XZ","marketInfo":"styles_marketInfo__xGHGL","gameLink":"styles_gameLink__JkTij"};